module.exports = __webpack_public_path__ + "static/media/bulkAd-sprite.28fd79b2.svg";